export const NOTIFICATION_RETENTION_DAYS = 30;
export const MESSAGE_GENERIC_RETENTION_DAYS = 30;
export const MESSAGE_IN_APP_RETENTION_DAYS = 365;
